import styled, { css } from 'styled-components';
import CloseIcon from '../../../../icons/Close';

export const Cstable = styled.div`
  display: table;
  border-collapse: collapse;
  width: 100%;
`;

export const Csrow = styled.div`
  display: table-row;
`;

export const Cscell = styled.div`
  display: table-cell;
  padding: 5px;
  border: 1px solid #d8d8d8;
`;

export const Baggage = styled.div`
  ${Cscell} {
    padding: 10px;
  }
  ${Cscell}:first-child {
    background-color: #fafafa;
    color: #222222;
  }
`;

export const CancellationRules = styled.div`
  .tableFare {
    width: 47%;
    float: left;
    margin-bottom: 20px;
  }
  .tableFare:nth-child(even) {
    float: right;
  }
  ${Cscell}:nth-child(even) {
    background-color: #fafafa;
    color: #222222;
  }
  ${Cscell} {
    width: 50%;
  }
`;

export const CloseIconRight = styled(CloseIcon)`
  position: absolute;
  right: 30px;
  top: 15px;
  cursor: pointer;
`;

export const BaggageHdWrap = styled.div`
  background: #f4f4f2;
  padding: 15px 20px 0;
  border-radius: 5px 5px 0 0;
`;

export const BaggageTab = styled.div`
  border: 1px solid #d8d8d8;
  float: left;
  width: 105px;
  padding: 10px;
  position: relative;
  margin-left: -1px;
  text-align: center;
  cursor: pointer;
  ${props =>
    props.isActive &&
    css`
      border-bottom: 1px solid #ffffff;
      background-color: #fff;
      margin-bottom: -1px;
      position: relative;
      z-index: 3;
    `}
`;

export const ModalBodyWrapper = styled.div`
  max-height: 550px;
  overflow-y: auto;
  padding: 17px 35px;
`;

export const PolicyTabsWrap = styled.div`
  display: flex;
  margin: 8px 0 15px;
  .policyTab {
    border-bottom: 4px solid #ffffff;
    padding: 12px 10px 10px;
    font-size: 14px;
    color: #4a4a4a;
    cursor: pointer;
  }
  .activePolicyTab {
    font-weight: 600;
    border-color: #008cff;
    color: #000000;
  }
`;
